// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".letrapreg[data-v-50d2115c]{color:#000!important}.verde[data-v-50d2115c]{color:green}.morado[data-v-50d2115c]{color:purple}", ""]);
// Exports
module.exports = exports;
